export class Notify {
  constructor(public data:NotifyData) {}
}

export class NotifyData {
  constructor(public token: string, public idTransaction: string, public response:Object) {}
}
